import { makeAutoObservable } from "mobx";

class VoiceStore {
    voiceCommand = "Welcome To Svasti";
    preferredLanguage = ""
    language = JSON.parse(sessionStorage.getItem("CommunicationLanguage")) || "English";
    constructor() {
        makeAutoObservable(this, {
            voiceCommand: true // Explicitly marking as observable for clarity
        });
    }

    setVoiceCommand(command) {
        this.voiceCommand = command;
    }

    setLanguage(lang) {
        this.language = lang;
    }
    setPreferredLanguage(preferredLang) {
        this.preferredLanguage = preferredLang
    }
}

export const voiceStore = new VoiceStore();
